import { all, takeLatest, put, retry, select, call } from 'redux-saga/effects';
import { addListMemberActions } from '$store/addListMember/index';
import { toastActions } from '$store/toast';
import { Api } from '$api';

function* loadMembersWorker() {
  try {
    const data = yield call(Api.post, '/lists/filter', {
      excludeLists: [],
      filters: [],
      lists: [],
      excludeBroadcastFilter: true,
    });
    console.log(data);
  } catch (e) {
    yield put(addListMemberActions.setLoadingStatus('failed'));
    yield put(toastActions.setToastFail(e.message));
  }
}

export function* addListMemberSaga() {
  yield all([takeLatest(addListMemberActions.loadMembers, loadMembersWorker)]);
}
